import { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FullConversation from './FullConversation';
import ConversationParts from './ConversationParts';
import SentencePractiseWrapper from './SentencePractiseWrapper';
import AudioListener from './AudioListener';
import useFetch from '../../../hooks/use-fetch';
import useAnalyticsEventTracker from '../../../hooks/use-analytics';
import { useTranslation } from 'react-i18next';

//Order shuffler
function randomiseOrder(buttonOrder) {
  let orginalArray = [...buttonOrder];
  let shuffledArray = shuffle(buttonOrder);

  // console.log(orginalArray);
  // console.log(shuffledArray);
  // console.log(JSON.stringify(orginalArray) === JSON.stringify(shuffledArray))

  //Check if strings match so we always get a random order
  //Only run if more than 1 button to avoid infinite loop!
  if (
    JSON.stringify(orginalArray) === JSON.stringify(shuffledArray) &&
    buttonOrder.length > 1
  ) {
    // console.log('Order same as previous. Reshuffling')
    randomiseOrder(buttonOrder);
  }

  return shuffledArray;
}

function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }

  return array;
}

const ConversationOptions = (props) => {
  const {t:translate} = useTranslation();
  const dispatch = useDispatch();
  const [showFullConversation, setShowFullConversation] = useState(false);
  const [allButtonsChecked, setAllButtonsChecked] = useState(false);
  const lesson = parseInt(useSelector((state) => state.currentLesson));
  const sceneID = useSelector((state) => state.currentSceneID);
  const activeConversation = useSelector((state) => state.activeSection);
  let showSection = false;
  const index = props.index;
  const score = useSelector((state) => state.currentButtonScore);
  const playNpcAudio = useSelector((state) => state.playNpcAudio);
  const { initFunc: dispatchProgressUpdate } = useFetch();
  const conversationData = useSelector((state) => state.conversationData);
  const gaEventTracker = useAnalyticsEventTracker(`Lesson ${conversationData.lesson}`);

  if (showFullConversation) {
    showSection = true;
  }

  if (activeConversation === index && playNpcAudio !== true) {
    showSection = true;
  }

  const createOrder = () => {
    let buttonOrder = [];
    for (let i = 0; i < props.splits.length; i++) {
      buttonOrder.push(i);
    }

    //Shuffle the order for lesson 2
    if (parseInt(lesson) === 2) {
      buttonOrder = randomiseOrder(buttonOrder);
    }

    return buttonOrder;
  };

  //Create order buttons need to be in
  let order = createOrder();

  const completeSection = () => {
    dispatch({
      type: 'resetConversationButton',
    });
    setShowFullConversation(true);
  };

  const sectionSkipped = () => {
    const { apiUrl } = window['appConfig'];
    const conversationId = parseInt(activeConversation) + 1;
    let fetchData = new URLSearchParams();
    fetchData.append('lesson', lesson);

    const fetchOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: fetchData,
    };

    const progressUrl = `${apiUrl}/progress/skip/${sceneID}/${conversationId}`;

    gaEventTracker('Sentence Skipped', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(activeConversation) + 1}`)
    dispatchProgressUpdate({ url: progressUrl, options: fetchOptions });
    completeSection();
  };

  useEffect(() => {
    let submittingGA = false;

    if (score >= 65 && lesson > 1 && activeConversation === index) {
      
        gaEventTracker('Sentence Passed', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(activeConversation) + 1}`)
      if( lesson === 2) {
        setTimeout(function () {
          completeSection();
        }, 1500);
      } 

      if( lesson === 3 ) {
        completeSection();
      }
    }
    
    if (score !== null && score < 65 && lesson > 1 && activeConversation === index) {
      if( submittingGA === false ) {
        gaEventTracker('Sentence Failed', `${conversationData.location} ${conversationData.sceneName} Lesson ${conversationData.lesson} Sentence ${parseInt(activeConversation) + 1}`)
      }
      submittingGA = true
    }

    return () => {
      submittingGA = false;
    }
  }, [score]);

  useEffect(() => {
    if (showFullConversation === true) {
      //delay next section showing so full text version has time to show
      setTimeout(function () {
        dispatch({
          type: 'updateActiveSection',
        });
      }, 750);
    }
  }, [showFullConversation]);

  let content = (
    <ConversationParts
      index={index}
      splits={props.splits}
      order={order}
      sentenceNumber={props.sentenceNumber}
      setShowFullConversation={setShowFullConversation}
      setAllButtonsChecked={setAllButtonsChecked}
    />
  );

  if (parseInt(lesson) === 2) {
    content = (
      <Fragment>
        <ConversationParts
          index={index}
          splits={props.splits}
          order={order}
          sentenceNumber={props.sentenceNumber}
          setAllButtonsChecked={setAllButtonsChecked}
        />

        {allButtonsChecked && (
          <SentencePractiseWrapper
            sectionIndex={props.index}
            parrotText={translate('lesson-2-prompt')}
            fullSentence={props.modelAnswerSentence}
          >
            {/* <InputSelector setShowFullConversation={setShowFullConversation} />   */}
            <AudioListener
              completeButton={sectionSkipped}
              buttonToggled={true}
              buttonComplete={false}
              npcFinished={true}
              part={index}
              autoPlay={false}
            />
          </SentencePractiseWrapper>
        )}
      </Fragment>
    );
  }

  if (parseInt(lesson) === 3) {
    const helpText = (
      <Fragment>
        <span>{translate('say')}</span>
        <br />
        <b>&#34;{props.modelAnswerSentenceNative}&#34;</b>
      </Fragment>
    );
    content = (
      <SentencePractiseWrapper sectionIndex={props.index} parrotText={helpText}>
        {/* <InputSelector setShowFullConversation={setShowFullConversation} /> */}
        <AudioListener
          completeButton={sectionSkipped}
          buttonToggled={true}
          buttonComplete={false}
          npcFinished={true}
          part={index}
          autoPlay={true}
        />
      </SentencePractiseWrapper>
    );
  }
  return (
    <div
      className={`conversation-options ${
        showSection === true ? 'conversation-options--active' : ''
      }`}
    >
      {showFullConversation === true ? (
        <FullConversation conversation={props.modelAnswerSentence} />
      ) : (
        content
      )}
    </div>
  );
};

export default ConversationOptions;
